import { render } from "./CarruselManual.vue?vue&type=template&id=dde6a18e&scoped=true"
import script from "./CarruselManual.vue?vue&type=script&lang=js"
export * from "./CarruselManual.vue?vue&type=script&lang=js"

import "./CarruselManual.vue?vue&type=style&index=0&id=dde6a18e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde6a18e"]])

export default __exports__